import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      meta: {
        title: "Home",
        requiresAuth: true,
      },
      path: "/",
      component: () => import("@/layouts/MasterLayout.vue"),
      children: [
        {
          name: "master",
          path: "/master",
          component: () => import("@/views/MasterView.vue"),
        },
        {
          name: "company",
          path: "/company",
          component: () => import("@/views/CompanyView.vue"),
        },
        {
          name: "cisterns",
          path: "/cisterns",
          component: () => import("@/views/CisternsView.vue"),
        },
        {
          name: "customers",
          path: "/customers",
          component: () => import("@/views/CustomerView.vue"),
        },
        {
          name: "billing",
          path: "/billing",
          component: () => import("@/views/BillingView.vue"),
        },
        {
          name: "driver",
          path: "/driver",
          component: () => import("@/views/DriversView.vue"),
        },
        {
          name: "addressees",
          path: "/addressees",
          component: () => import("@/views/AddresseesView.vue"),
        },
        {
          name: "supplier",
          path: "/supplier",
          component: () => import("@/views/SupplierView.vue"),
        },
        {
          name: "load",
          path: "/load",
          component: () => import("@/views/LoadsView.vue"),
        },
        {
          name: "zones",
          path: "/zones",
          component: () => import("@/views/ZonesView.vue"),
        },
        {
          name: "dashboard",
          path: "/dashboard",
          component: () => import("@/views/DashboardView.vue"),
        },

        {
          name: "Rticket",
          path: "/Rticket",
          component: () => import("@/views/report/TicketView.vue"),
        },

        {
          name: "Rguide",
          path: "/Rguide",
          component: () => import("@/views/report/GuideView.vue"),
        },

        {
          name: "Rload",
          path: "/Rload",
          component: () => import("@/views/report/LoadView.vue"),
        },

        {
          name: "Rkardex",
          path: "/Rkardex",
          component: () => import("@/views/report/KardexView.vue"),
        },

        {
          name: "Rpreview",
          path: "/Rpreview",
          component: () => import("@/views/report/TicketPreview.vue"),
        },
        {
          name: "Cticket",
          path: "/Cticket",
          component: () => import("@/views/customer/TicketCustomerView.vue"),
        },

        {
          name: "Cguide",
          path: "/Cguide",
          component: () => import("@/views/customer/GuideCustomerView.vue"),
        },
      ],
    },
    {
      meta: {
        title: "Login",
      },
      path: "/login",
      name: "login",
      component: () => import("@/views/LoginView.vue"),
    },

    {
      path: "/:pathMatch(.*)*",
      redirect: "/login",
    },
  ],
});

// Navigation Guard
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !store.state.isAuthenticated) {
    next({ name: "login" });
  } else if (to.name === "login" && store.state.isAuthenticated) {
    if (store.state.role === "ROOT") {
      next({ name: "master" });
    } else if (store.state.role === "MASTER") {
      next({ name: "company" });
    } else if (store.state.role === "COMPANY") {
      next({ name: "dashboard" });
    } else if (store.state.role === "CUSTOMER") {
      next({ name: "Cticket" });
    } else {
      next();
    }
  } else if (to.path === "/" && store.state.isAuthenticated) {
    if (store.state.role === "ROOT") {
      next({ name: "master" });
    } else if (store.state.role === "MASTER") {
      next({ name: "company" });
    } else if (store.state.role === "COMPANY") {
      next({ name: "dashboard" });
    } else if (store.state.role === "CUSTOMER") {
      next({ name: "Cticket" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
